<template>
  <div class="evaluation-home">
    <nav-bar
      fixed
      z-index="99"
      title="测评介绍"
      left-text="返回"
      left-arrow
      placeholder
      @click-left="backRouter"
      right-text="个人中心"
      @click-right="$router.push('/user')"
    />
    <div
      class="evaluation-home-head"
      :style="`background-image: url(${headerImg});`"
    >
      <div class="evaluation-home-head-title">
        蒲公英青少年全人发展 生态系统测评
      </div>
    </div>
    <div class="evaluation-home-content">
      <EvaluationBox class="evaluation-home-content-item" title="测评介绍">
        <div class="html-content" v-html="reviewConfig.present"></div>
      </EvaluationBox>
      <EvaluationBox class="evaluation-home-content-item" title="测评设计依据">
        <div class="html-content" v-html="reviewConfig.design_basis"></div>
      </EvaluationBox>
      <EvaluationBox class="evaluation-home-content-item" title="你将获得">
        <div class="html-content" v-html="reviewConfig.obtain"></div>
      </EvaluationBox>
      <EvaluationBox class="evaluation-home-content-item" title="报告示例">
        <div class="html-content" v-html="reviewConfig.report_example"></div>
      </EvaluationBox>
      <EvaluationBox
        class="evaluation-home-content-item"
        title="蒲公英家庭教练中心研发团队"
      >
        <div class="html-content" v-html="reviewConfig.team"></div>
      </EvaluationBox>
    </div>

    <div class="evaluation-home-self">
      <span
        class="evaluation-home-self-text"
        @click="$router.push('/evaluation/my')"
        >我的测评</span
      >
    </div>

    <div class="evaluation-home-footer">
      <div class="evaluation-home-footer-start" @click="goEvaluation">
        立即测评
      </div>
    </div>

    <!-- <div class="evaluation-home-self">
      <div class="evaluation-home-self-btn" @click="goEvaluation">立即测评</div>
    </div>


    <div class="evaluation-home-footer">
      <div class="evaluation-home-footer-start" @click="$router.push('/evaluation/my')">
        我的测评
      </div>
    </div> -->
  </div>
</template>

<script>
import EvaluationBox from "@/components/evaluation/EvaluationBox.vue";
import { getReviewConfig } from "@/api/evaluation";
import { getSystemConfig } from "@/api/public";
import { NavBar } from "vant";
import cookie from "@utils/store/cookie";

export default {
  data() {
    return {
      reviewConfig: {},
      headerImg: "",
    };
  },
  components: {
    EvaluationBox,
    NavBar,
  },
  mounted() {
    this.getSystemConfig();
    this.getReviewConfig();
  },
  methods: {
    // 获取头部图片配置
    getSystemConfig() {
      getSystemConfig({ name: "evaluation_header_img" }).then((res) => {
        this.headerImg = res.data;
      });
    },
    goEvaluation() {
      this.$router.push({
        path: "/evaluation/choose",
      });
    },
    getReviewConfig() {
      getReviewConfig().then((res) => {
        this.reviewConfig = res.data;
      });
    },
    backRouter() {
      const preRouter = cookie.get("preRouter") || '/';

      if(preRouter == '/'){
        this.$router.push('/');
      }else {
        this.$router.go(-1)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.evaluation-home {
  background-color: #fff;

  &-head {
    background-image: url("~@/assets/evaluation/header.png");
    height: 2.3rem;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
    position: relative;

    &-title {
      position: absolute;
      top: 0.97rem;
      left: 0.6rem;
      color: rgb(255, 196, 0);
      font-weight: bold;
      font-family: DINAlternate-Bold;
      font-size: 0.35rem;
      text-wrap: wrap;
      width: 3.5rem;
    }
  }

  &-content {
    padding: 0.2rem 0.3rem;

    &-item {
      margin: 0.3rem 0;
    }
  }

  &-self {
    font-size: 0.25rem;
    color: #666;
    display: flex;
    justify-content: center;
    padding: 0.2rem 0 0.8rem 0;
    margin-bottom: 1rem;

    &-text {
      text-align: center;
      border-bottom: 0.03rem solid #666;
      padding-bottom: 0.05rem;
    }

    &-btn {
      color: #fff;
      background-color: rgb(244, 90, 85);
      border-radius: 2rem;
      font-size: 0.3rem;
      width: 40%;
      text-align: center;
      padding: 0.1rem;
    }
  }

  &-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1.2rem;
    background-color: rgb(255, 200, 55);

    display: flex;
    align-items: center;
    padding: 0rem 0.3rem;

    &-start {
      width: 100%;
      background-color: #fff;

      font-size: 0.3rem;
      font-weight: bold;
      border-radius: 5rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.35rem;
      padding: 0.1rem 0.35rem;
      color: #000;

      // box-shadow: 3px 3px 7px rgba(0, 0, 0, .4), 1px 1px 1px rgba(255, 255, 255, .9);
      border: 2px solid #ccc;
      box-shadow: 2px 2px 3px rgba(0, 0, 0, 0.5);
    }
  }
}

::v-deep .van-nav-bar {
  background-color: rgb(255, 196, 0) !important;
}
</style>
